import { zetApi } from '@zet/network'
import storageUtil from '@zet/utils/storage'

export const verifyOtp = async ({
  mobileNumber,
  value,
}: {
  mobileNumber: string
  value: string
}) => {
  if (value && mobileNumber) {
    const response = await zetApi.post('/signup/generate_token/v3', {
      phonenumber: mobileNumber,
      password: value,
    })
    response?.data?.refreshToken &&
      storageUtil.saveObject('refreshToken', response?.data.refreshToken)
    response?.data?.expiryDate &&
      storageUtil.saveObject('expiryDate', response?.data.expiryDate)
    return response
  } else {
    throw new Error('Phone Number or OTP is invalid')
  }
}
